/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlDto
 */
export interface ControlDto {
    /**
     * 
     * @type {string}
     * @memberof ControlDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDto
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDto
     */
    controlClass?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDto
     */
    controlStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDto
     */
    catalogName?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDto
     */
    groupName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDto
     */
    hasParameters?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDto
     */
    hasParts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDto
     */
    hasSubControls?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDto
     */
    parentControlId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ControlDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlDto
     */
    updated?: Date;
}

/**
 * Check if a given object implements the ControlDto interface.
 */
export function instanceOfControlDto(value: object): value is ControlDto {
    return true;
}

export function ControlDtoFromJSON(json: any): ControlDto {
    return ControlDtoFromJSONTyped(json, false);
}

export function ControlDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'controlClass': json['controlClass'] == null ? undefined : json['controlClass'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'controlStatus': json['controlStatus'] == null ? undefined : json['controlStatus'],
        'status': json['status'] == null ? undefined : json['status'],
        'catalogName': json['catalogName'] == null ? undefined : json['catalogName'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'hasParameters': json['hasParameters'] == null ? undefined : json['hasParameters'],
        'hasParts': json['hasParts'] == null ? undefined : json['hasParts'],
        'hasSubControls': json['hasSubControls'] == null ? undefined : json['hasSubControls'],
        'parentControlId': json['parentControlId'] == null ? undefined : json['parentControlId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
    };
}

export function ControlDtoToJSON(json: any): ControlDto {
    return ControlDtoToJSONTyped(json, false);
}

export function ControlDtoToJSONTyped(value?: ControlDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'controlId': value['controlId'],
        'controlClass': value['controlClass'],
        'title': value['title'],
        'description': value['description'],
        'controlStatus': value['controlStatus'],
        'status': value['status'],
        'catalogName': value['catalogName'],
        'groupName': value['groupName'],
        'hasParameters': value['hasParameters'],
        'hasParts': value['hasParts'],
        'hasSubControls': value['hasSubControls'],
        'parentControlId': value['parentControlId'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
    };
}

